
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import UploadImg from '@/components/upload-img.vue';
	import Switch from '@/components/switch.vue';
	import previewImg from '@/components/previewImg.vue';
	import Dialog from '@/components/dialog.vue';
	import ChoosePages from '@/components/choosepages/choosepages.vue';
	import Message from '@/components/message.vue';
  import {
		getOssToken
	} from '@/api/user'
	import {
		productList,
		productCategory
	} from '@/api/supplier'
  import {
    playScreenAdvertisingplayScreenAdvertisingSave,
    playScreenAdvertisingplayScreenAdvertisingInfo,
    custompagecustompagelist,
    playScreenAdvertisingplayScreenAdvertisingPageList,
    playScreenAdvertisingplayScreenAdvertisingDelete
  } from "@/api/material"
	import{
		getSearchDate,
		nextDay,
    nowtime,
    chooseLinkConvert,
    getDataConvert
	}from "@/utils/index"
  @Component({  
    name: '',
    components: {
      PageFooter,
      UploadImg,
      'slz-switch': Switch,
      previewImg,
			'slz-dialog': Dialog,
      ChoosePages,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
    private tablelist:any = []
    private tableloading = false
		private pageNo = 1;
		private pageSize = 12;
		private total = 0;
    private relationlist = [
      {value:1,label:'商品'},
      {value:2,label:'商品分类'},
      {value:3,label:'自定义页面'},
    ]
    private gradeList = [ {
				label: '联创',
				value: 1
			}, {
				label: '核心',
				value: 2
			},{
				label: '总代',
				value: 3
			}, {
				label: '客户',
				value: 0
			}
		];
    private classityList:any = []
    private shoplist:any = []
    private token:any = {}
    private showPreview = false
    private fileType = 'image'
    private currentUrl = 'http://cdn2024.routuan.com/routuan/image/46bfb02a6a79cf2ab3a004c39f4b737.jpg'
    private pageList:any = []
    private EditShow = false
    private EditLoading = false
    private rowmsg:any = {}
    private chooseShow = false
    private chooseMsg:any = {}
    private delShow = false

    private mounted () {
      this.gettablelist()
    }
    

    private async gettablelist(){
      try{
        this.tableloading = true
        let res = await playScreenAdvertisingplayScreenAdvertisingPageList({
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.OpenObjectValue = this.gradeList.filter(x=>v.OpenObject.some(z=>z==x.value)).map(x=>x.label).join('、')
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async confirmDel(){
      try{
        this.tableloading = true
        let res = await playScreenAdvertisingplayScreenAdvertisingDelete({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private delOpt(row){
      this.rowmsg = row
      this.delShow = true
    }
    private editMsg(e){
      if(e.Id==0){
        // console.log(nowtime())
        this.rowmsg = {
          ImgUrl:'',
          RelationType:'',
          RelationTypeValue:'',
          RelationId:'',
          RelationValue:'',
          IsDisplay:'',
          StartTime:nowtime(),
          EndTime:'',
          OpenObject:[0,1,2,3],
          JumpPath:'',
          IsJumpExternalWxApp:false,
          ExternalWxAppId:'',
          ExternalWxAppOriginalId:'',
          JumpPageName:'',
        }
        this.chooseMsg = {}
      }else{
        this.rowmsg = e
        this.getinfo()
      }
      this.EditShow = true
    }
		private getdata(e){
			this.chooseMsg = e
      this.rowmsg.RelationType = getDataConvert(e.pagetype,e.subdivideType)
			
			this.rowmsg.RelationTypeValue = e.pagetypelabel
			this.rowmsg.RelationId = e.Id
			this.rowmsg.RelationValue = e.label
			this.rowmsg.JumpPath = e.pageurl
			this.rowmsg.IsJumpExternalWxApp = e.IsJumpExternalWxApp
			this.rowmsg.ExternalWxAppId = e.ExternalWxAppId
			this.rowmsg.ExternalWxAppOriginalId = e.ExternalWxAppOriginalId
			this.rowmsg.JumpPageName = e.JumpPageName
			this.chooseShow = false
		}
		private clearValue(){
			this.rowmsg.RelationType = ''
			this.rowmsg.RelationTypeValue = ''
			this.rowmsg.RelationId = ''
			this.rowmsg.RelationValue = ''
      this.rowmsg.JumpPath = ''
			this.rowmsg.IsJumpExternalWxApp = false
			this.rowmsg.ExternalWxAppId = ''
			this.rowmsg.ExternalWxAppOriginalId = ''
			this.rowmsg.JumpPageName = ''
			this.chooseMsg = {}
		}
    private changetype(){
      this.chooseShow = true
    }
    private async getcustompage(){
			try{
				let res = await custompagecustompagelist({
					PageName:'',
					Skip:0,
					Take:99999
				})
				if(res.IsSuccess){
					this.pageList = res.Result.Results
				}
			}finally{
				//
			}
		}
    private async getinfo(){
      try{
        let res = await playScreenAdvertisingplayScreenAdvertisingInfo({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          // console.log(res.Result)
          this.chooseMsg = {
            ...chooseLinkConvert(res.Result.RelationType),
            ...res.Result,
            Id:res.Result.RelationId
          }
          console.log(this.chooseMsg,123)
          this.rowmsg = {
            ...res.Result,
            RelationId:res.Result.RelationId||'',
            RelationType:res.Result.RelationType||'',
            RelationValue:res.Result.RelationValue||'',
						JumpPath:res.Result.JumpPath||'',
						IsJumpExternalWxApp:res.Result.IsJumpExternalWxApp||false,
						ExternalWxAppId:res.Result.ExternalWxAppId||'',
						ExternalWxAppOriginalId:res.Result.ExternalWxAppOriginalId||'',
          }
          
        }
      }finally{
        //
      }
    }
    private testfull(){
      let rowmsg = JSON.parse(JSON.stringify(this.rowmsg))
      if(!rowmsg.ImgUrl){
        this.$message.error('请上传广告图片')
        return false
      }
      if([rowmsg.StartTime,rowmsg.EndTime].filter(v=>v).length<2){
				this.$message.error('请完善时间段')
				return
			}
      if(new Date(rowmsg.StartTime).getTime()>=new Date(rowmsg.EndTime).getTime()){
				this.$message.error('结束时间不能早于开始时间')
				return
			}
      return true
    }
    private async submit(){
      if(!this.testfull()) return
      let rowmsg = JSON.parse(JSON.stringify(this.rowmsg))
      try{
        let res = await playScreenAdvertisingplayScreenAdvertisingSave({
          Info:rowmsg
        })
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.EditShow = false
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private handleUpload(list){
      this.rowmsg.ImgUrl = list[0]
    }
  }
